import React, { useEffect } from "react";
import { MdClose } from "react-icons/md";
import { useViewerStore } from "../../../../store/store";

/** Sync body flag so CSS can dock Street View as a bottom drawer on mobile/tablet. */
function syncStreetViewBottomOpen(isOpen: boolean) {
    const useBottomDrawer = document.body.classList.contains("mobile-bottom-layout");
    document.body.classList.toggle("street-view-bottom-open", isOpen && useBottomDrawer);
}

const StreetView: React.FC = () => {
    const sceneViewer = useViewerStore((state) => state.sceneViewer);
    const isStreetViewVisible = useViewerStore((state) => state.isStreetViewVisible);

    useEffect(() => {
        const onResize = () => syncStreetViewBottomOpen(isStreetViewVisible);
        syncStreetViewBottomOpen(isStreetViewVisible);
        window.addEventListener("resize", onResize);
        return () => {
            window.removeEventListener("resize", onResize);
            document.body.classList.remove("street-view-bottom-open");
        };
    }, [isStreetViewVisible]);

    const closeStreetView = () => {
        const streetViewContainer = document.getElementById("google-street-view-container");
        const canvasContainer = document.getElementById("canvasContainer");

        if (streetViewContainer) {
            streetViewContainer.style.display = "none";
        }

        if (canvasContainer) {
            canvasContainer.classList.remove("canvas-street-view-split");
        }

        document.body.classList.remove("street-view-bottom-open");

        if (sceneViewer) {
            sceneViewer.isViewerInSplitMode = false;
            setTimeout(() => {
                sceneViewer.resizeCanvas();
            }, 500);
        }

        useViewerStore.setState({
            isStreetViewVisible: false,
            isRightSidebarOpen: true,
        });
    };

    return (
        <div className="street-view no-pointer-events" id="google-street-view-container">
            <button type="button" onClick={closeStreetView} className="street-view--close" aria-label="Close Street View">
                <MdClose size={24} />
            </button>
            <iframe loading="lazy" className="street-view-iframe" title="Google Street View"></iframe>
        </div>
    );
};

export default StreetView;
